import { JobSearchBanner } from '@/design-system/molecules/JobSearchBanner';

const IntegrationCtaBanner = (props) => {
    return <JobSearchBanner {...props} />;
};

export default IntegrationCtaBanner;
